// extracted by mini-css-extract-plugin
export default {"filters":"styles_filters__rG8pW","filter":"styles_filter__r0dQz","loader":"styles_loader__HlDjb"};